(() => {
  const root = document.querySelector('[data-gdefy-adv]');
  if (!root || root.dataset.gdInitialized) return;
  root.dataset.gdInitialized = 'true';
  const bar = root.querySelector('[data-quiz="progress-pct"]');
  const sticky = root.querySelector('#gdefy-adv-sticky-bar');
  let ticking = false;
  function update() {
    ticking = false;
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const amount = Math.min(1, Math.max(0, window.scrollY / max));
    if (bar) bar.style.width = `${amount * 100}%`;
    // Source mobile fixed bar stays visible once reading has begun.
    if (sticky) sticky.classList.toggle('is-active', window.innerWidth <= 991 && window.scrollY > 320);
  }
  function schedule() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  update();
  const current = new URL(window.location.href);
  const campaignKeys = ['gclid', 'fbclid', 'msclkid', 'tw_source', 'tw_campaign', 'tw_adid'];
  root.querySelectorAll('[data-gd-purchase]').forEach((link) => {
    const destination = new URL(link.getAttribute('href'), window.location.origin);
    current.searchParams.forEach((value, key) => {
      if (key.startsWith('utm_') || campaignKeys.includes(key)) destination.searchParams.set(key, value);
    });
    destination.searchParams.set('utm_content', `gdefy-adv-${link.dataset.gdPurchase}`);
    link.href = destination.origin === window.location.origin
      ? `${destination.pathname}${destination.search}${destination.hash}`
      : destination.href;
  });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) root.querySelectorAll('video').forEach((video) => video.pause());
})();
